import BaseMapStyle from "@mapmycustomers/shared/enum/map/BaseMapStyle";

import googleMapStyles from "@app/component/map/googleMapStyles";

const applyBaseMapStyle = (map: google.maps.Map, style: BaseMapStyle): void => {
  switch (style) {
    case BaseMapStyle.HYBRID:
      map.setMapTypeId("hybrid");
      map.setOptions({ styles: undefined });
      break;
    case BaseMapStyle.SATELLITE:
      map.setMapTypeId("satellite");
      map.setOptions({ styles: undefined });
      break;
    default:
      map.setMapTypeId("roadmap");
      map.setOptions({ styles: googleMapStyles[style] });
  }
};

export default applyBaseMapStyle;
